import styled from 'styled-components';
import {
  compose,
  fontStyle,
  fontSize,
  FontStyleProps,
  fontWeight,
  FontWeightProps,
  FontSizeProps,
  system,
  color,
  margin,
  padding,
  ColorProps,
  MarginProps,
  PaddingProps,
  LayoutProps,
  layout,
  textStyle,
  TextStyleProps,
  FlexProps,
  flex,
} from 'styled-system';

export const Span = styled.span<TextStyleProps | FlexProps | LayoutProps | FontStyleProps | FontWeightProps | FontSizeProps | ColorProps | MarginProps | PaddingProps | { bold: boolean }>(
  compose(
    fontStyle,
    fontSize,
    fontWeight,
    color,
    margin,
    padding,
    layout,
    flex,
    textStyle,
    system({
      bold: {
        property: 'fontWeight',
        transform: (value: boolean) => (value ? 'bold' : 'none'),
      },
    })
  )
);

Span.displayName = 'Span';
Span.defaultProps = {
  display: 'flex',
};
